import React from 'react';
import _ from 'lodash';

import FIELD_TYPES from '../../configs/fieldTypes';
import { FORMULA_TYPES } from '../../configs/formula';
import { VALUE_STATUSES } from '../../configs/import';
import { Field } from './BaseClass.js';

// Iframe-поле не отображается в инлайн-контекстах (таблица, kanban-карточки,
// календарь) — по аналогии с полем "Кнопка". Stub нужен потому что CellData
// в ветке c CellWrap рендерит компонент без проверки на undefined.
const IframeInlineStub = () => null;
IframeInlineStub.displayName = 'IframeInlineStub';

export default class Iframe extends Field {
  static type = FIELD_TYPES.IFRAME;

  static availableFormulaTypes = [FORMULA_TYPES.FORMULA, FORMULA_TYPES.LOOKUP];

  static availableInFormulas = true;

  static formulaDataType = 'string';

  static components = {
    inline: IframeInlineStub,
    control: require('../../components/common/UI/ControlList/controls/Iframe').default,
  };

  static getCanComponentExpandWidthOrHeight = (field, singleFieldInSection, singleFieldInTab) => ({
    canExpandWidth: singleFieldInSection,
    canExpandWidthAndHeight: singleFieldInTab,
  });

  static parseValue = (field, value) => {
    if (Iframe.isEmpty(value)) {
      return { value: Iframe.getEmptyValue(), status: VALUE_STATUSES.VALID };
    }
    if (_.isString(value)) {
      return { value: _.trim(value), status: VALUE_STATUSES.VALID };
    }
    return { value: String(value), status: VALUE_STATUSES.VALID };
  };

  static validateValue = (field, value) => {
    if (value == null || _.isString(value)) return true;
    return false;
  };

  static getEmptyValue = () => '';

  static isEmpty = (value) => !value;

  static createComponent = (field, value, type) => {
    const Component = Iframe.components[type];
    return ({ containerClassName }) => {
      if (!Component || Iframe.isEmpty(value)) return null;
      return <Component config={field.get('config')} value={value} containerClassName={containerClassName} />;
    };
  };

  static validateRequired = (value) => value == null || value === '';

  static checkChangeYourself = () => false;
}
